import { render } from "./index.vue?vue&type=template&id=5ca53955"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/page-heading/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ca53955"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ca53955', __exports__)) {
    api.reload('5ca53955', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5ca53955", () => {
    api.rerender('5ca53955', render)
  })

}


export default __exports__